<div class="message-scroll error-message-area">
    <div *ngFor="let errorMessage of errorMessageModelArray">
        <mat-card [class]="errorMessage.messageClass">
            <mat-card-content><!-- fxLayout="row nowrap"> -->

                <div class="tw-flex tw-flex-row">
                    <div class="tw-flex tw-flex-col tw-flex-wrap tw-justify-center">
                        <!-- fxLayout="column wrap" fxLayoutAlign="center" -->
                        <mat-icon class="" [class]="errorMessage.iconClass">{{errorMessage.icon}}</mat-icon>
                    </div>
                    <div flex class="message-area">
                        {{errorMessage.message}}
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>